import { Link } from 'react-router-dom';
import {
  Card,
  CardButton,
  Content,
  Heading,
  Secondary,
  Stack,
} from '@kinesis/bungle';

// A single action tile for the Inventory Home page's call-out row: a
// `CardButton` link into the flow. Store-less + presentational
// (Storybook-renderable) per the front-end split.
const CalloutCard = (props: CalloutCardProps) => {
  const { title, description, to } = props;

  return (
    <Content borderRadiusSize='small'>
      <Card>
        <CardButton as={Link} to={to}>
          <Content padding='medium' paddingMode='equal'>
            <Stack space='xsmall'>
              <Heading as='h3' size='medium'>
                {title}
              </Heading>
              <Secondary>{description}</Secondary>
            </Stack>
          </Content>
        </CardButton>
      </Card>
    </Content>
  );
};

export type CalloutCardProps = {
  title: string;
  description: string;
  to: string;
};

export { CalloutCard };
